import axios from '../../apis/approvalsApi';

export const FETCH_USER_EXCEPTION_REQUEST = 'FETCH_USER_EXCEPTION_REQUEST';
export const FETCH_USER_EXCEPTION_SUCCESS = 'FETCH_USER_EXCEPTION_SUCCESS';
export const FETCH_USER_EXCEPTION_FAILURE = 'FETCH_USER_EXCEPTION_FAILURE';

export const DELETE_USER_EXCEPTION_REQUEST = 'DELETE_USER_EXCEPTION_REQUEST';
export const DELETE_USER_EXCEPTION_SUCCESS = 'DELETE_USER_EXCEPTION_SUCCESS';
export const DELETE_USER_EXCEPTION_FAILURE = 'DELETE_USER_EXCEPTION_FAILURE';

export const ADD_USER_EXCEPTION_REQUEST = 'ADD_USER_EXCEPTION_REQUEST';
export const ADD_USER_EXCEPTION_SUCCESS = 'ADD_USER_EXCEPTION_SUCCESS';
export const ADD_USER_EXCEPTION_FAILURE = 'ADD_USER_EXCEPTION_FAILURE';


export const UPDATE_MSG_ADD = 'UPDATE_MSG_ADD';

export const fetchUserExceptionDataRequest = () => ({
    type: FETCH_USER_EXCEPTION_REQUEST,
});

export const fetchUserExceptionSuccess = (data) => ({
    type: FETCH_USER_EXCEPTION_SUCCESS, payload: data,
});

export const fetchUserExceptionFailure = (error) => ({
    type: FETCH_USER_EXCEPTION_FAILURE, payload: error,
});


export const deleteUserExceptionDataRequest = () => ({
    type: DELETE_USER_EXCEPTION_REQUEST,
});

export const deleteUserExceptionSuccess = (data) => ({
    type: DELETE_USER_EXCEPTION_SUCCESS, payload: data,
});

export const deleteUserExceptionFailure = (error) => ({
    type: DELETE_USER_EXCEPTION_FAILURE, payload: error,
});


export const addUserExceptionDataRequest = () => ({
    type: ADD_USER_EXCEPTION_REQUEST,
});

export const addUserExceptionSuccess = (data) => ({
    type: ADD_USER_EXCEPTION_SUCCESS, payload: data,
});

export const addUserExceptionFailure = (error) => ({
    type: ADD_USER_EXCEPTION_FAILURE, payload: error,
});

export const updateMsgAdd = (msg) => ({
    type: UPDATE_MSG_ADD, payload: msg,
});

export const fetchUserExceptionData = (jwt) => async (dispatch) => {
    try {
        dispatch(fetchUserExceptionDataRequest());
        const headers = {
            'Authorization': 'Bearer ' + jwt,
        };

        // Make GET request
        const response = await axios.get('/ZoomLicense/UserException', { headers: headers });
        console.log(response);
        dispatch(fetchUserExceptionSuccess(response.data));
    } catch (ex) {
        dispatch(fetchUserExceptionFailure(ex.response?.data || ex.message));
    }
};

/**
 * Action creator for deleting a user exception.
 * @param {Object} params - Parameters for the action.
 * @param {string} params.userId - The ID of the user exception to be deleted.
 * @param {string} params.jwt - JSON Web Token for authentication.
 * @returns {Function} - Async function dispatching actions based on the API response.
 */
export const deleteUserException = ({ userId, jwt }) => async (dispatch) => {
    try {
        // Dispatch the action to indicate that the request is in progress.
        dispatch(deleteUserExceptionDataRequest());

        // Set up the headers for the request, including the JWT for authentication.
        const headers = {
            'Authorization': 'Bearer ' + jwt,
        };

        // Make a DELETE request to the API endpoint for deleting a user exception.
        const response = await axios.delete('/ZoomLicense/UserException/' + userId, { headers: headers });

        // Log the response for debugging purposes.
        console.log(response);

        // Check the status code of the response and dispatch corresponding actions.
        if (response.status === 200) {
            dispatch(deleteUserExceptionSuccess(userId));
        } else {
            dispatch(deleteUserExceptionFailure(response.statusText));
        }
    } catch (ex) {
        // If an exception occurs during the request, dispatch an action with the error information.
        dispatch(deleteUserExceptionFailure(ex.response?.data || ex.message));
    }
};

/**
 * Action creator for adding a user exception.
 * @param {Object} params - Parameters for the action.
 * @param {string} params.userId - The ID of the user to be added as an exception.
 * @param {string} params.jwt - JSON Web Token for authentication.
 * @returns {Function} - Async function dispatching actions based on the API response.
 */
export const addUserException = ({ userId, jwt }) => async (dispatch) => {
    try {
        // Dispatch the action to indicate that the request is in progress.
        dispatch(addUserExceptionDataRequest());

        // Set up the headers for the request, including the JWT for authentication.
        const headers = {
            'Authorization': 'Bearer ' + jwt,
        };

        // Make a POST request to the API endpoint for adding a user exception.
        const response = await axios.post('/ZoomLicense/UserException', { userId }, { headers: headers });

        // Log the response for debugging purposes.
        console.log(response);

        // Dispatch an action with the data from the response to indicate success.
        dispatch(addUserExceptionSuccess(response.data));
    } catch (ex) {
        // If an exception occurs during the request, dispatch an action with the error information.
        dispatch(addUserExceptionFailure(ex.response?.data || ex.message));
    }
};

export const updateAddErrorMsg = (msg) => (dispatch) => {
    dispatch(addUserExceptionFailure(msg));
};
